<template>
  <!-- The KodeAI mark, traced from its icon (1024 × 1024, transparent): the
       "k" — a near-black stem and the blue chevron beside it — and two
       four-point sparkles, each shading from periwinkle at its top left to
       the chevron's blue at its bottom right. It is drawn for a light ground
       (white, or the support chat's pale tints), and fills its box: whatever
       holds it sets the room around it. `twinkle` sets the sparkles pulsing
       while Kode thinks. -->
  <svg
    class="kai-logo"
    :class="{ 'is-twinkling': twinkle }"
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <defs>
      <!-- Per sparkle, corner to corner: periwinkle at the top left, the chevron's blue at the bottom right. -->
      <linearGradient :id="sparkleId" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stop-color="#7A93CC" />
        <stop offset="1" stop-color="#4867AF" />
      </linearGradient>
    </defs>
    <rect x="72.75" y="125.25" width="129.5" height="805" fill="#21232B" />
    <path d="M450.75 389.5H604.75L387.75 657.25L604.75 926.75H450.75L232 657.25Z" fill="#4867AF" />
    <!-- Each sparkle: four curves, tip to tip, each bowed in towards the
         centre (its control point 15% of the way out along the diagonal). -->
    <path
      class="kai-logo__sparkle kai-logo__sparkle--big"
      :fill="`url(#${sparkleId})`"
      d="M793.75 93.75Q813.44 205.31 925 225Q813.44 244.69 793.75 356.25Q774.06 244.69 662.5 225Q774.06 205.31 793.75 93.75Z"
    />
    <path
      class="kai-logo__sparkle kai-logo__sparkle--small"
      :fill="`url(#${sparkleId})`"
      d="M898.75 382.5Q906.63 427.13 951.25 435Q906.63 442.88 898.75 487.5Q890.88 442.88 846.25 435Q890.88 427.13 898.75 382.5Z"
    />
  </svg>
</template>
<script>
// Each mark draws its own gradient: one id shared by several would make all
// of them use the first, which a hidden panel would leave unpainted.
let nextId = 0;

export default {
  name: 'KodeAiLogo',
  props: {
    twinkle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    nextId += 1;
    return {
      sparkleId: `kai-logo-sparkle-${nextId}`,
    };
  },
};
</script>
<style scoped>
.kai-logo {
  display: block;
  width: 100%;
  height: 100%;
  overflow: visible;
}

/* Each sparkle turns and scales about its own centre. */
.kai-logo__sparkle {
  transform-box: fill-box;
  transform-origin: center;
  transition: transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.kai-logo.is-twinkling .kai-logo__sparkle--big {
  animation: kai-logo-twinkle 1.6s ease-in-out infinite;
}

.kai-logo.is-twinkling .kai-logo__sparkle--small {
  animation: kai-logo-twinkle 1.6s ease-in-out 0.45s infinite;
}

@keyframes kai-logo-twinkle {
  0%, 100% { transform: scale(1) rotate(0deg); opacity: 1; }
  50% { transform: scale(0.7) rotate(45deg); opacity: 0.7; }
}

@media (prefers-reduced-motion: reduce) {
  .kai-logo__sparkle {
    transition: none;
  }

  .kai-logo.is-twinkling .kai-logo__sparkle--big,
  .kai-logo.is-twinkling .kai-logo__sparkle--small {
    animation: none;
  }
}
</style>
